export const GET_TOKEN_DETAILS = "GET_TOKEN_DETAILS"
export const GET_TOKEN_DETAILS_FAIL = "GET_TOKEN_DETAILS_FAIL"
export const GET_TOKEN_DETAILS_SUCCESS = "GET_TOKEN_DETAILS_SUCCESS"
export const GET_TOKEN_DETAILS_RESET = "GET_TOKEN_DETAILS_RESET"

export const getTokenDetails = (params) => {
    return { type: GET_TOKEN_DETAILS, params }
}

export const getTokenDetailsSuccess = (response) => {
    return { type: GET_TOKEN_DETAILS_SUCCESS, response }
}

export const getTokenDetailsFail = (response) => {
    return { type: GET_TOKEN_DETAILS_FAIL, response }
}

export const getTokenDetailsReset = () => {
    return { type: GET_TOKEN_DETAILS_RESET }
}